export const symbolStringPrune = (symbol) => {
    if (!symbol) {
        throw new Error(`${symbolStringPrune.name}: Symbol 不見了！ :${typeof symbol}=${symbol}`);
    }
    return symbol.replace(/[\s\S]+:/, '');
};
